module.exports = __webpack_public_path__ + "img/47.76869c49.jpg";